var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_2397)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.9208 19.568C9.9698 18.825 9.1995 17.8763 8.66778 16.7929C8.13605 15.7095 7.85675 14.5198 7.85083 13.313C7.82683 8.97697 11.3228 5.36797 15.6578 5.26797C17.3378 5.22728 18.988 5.71667 20.3742 6.66671C21.7604 7.61675 22.8122 8.97919 23.3804 10.5607C23.9486 12.1423 24.0043 13.8626 23.5397 15.4775C23.075 17.0925 22.1136 18.5202 20.7918 19.558C20.5003 19.784 20.264 20.0735 20.101 20.4044C19.938 20.7354 19.8524 21.0991 19.8508 21.468V22.068C19.8508 22.2801 19.7665 22.4836 19.6165 22.6337C19.4665 22.7837 19.263 22.868 19.0508 22.868H12.6508C12.4387 22.868 12.2352 22.7837 12.0851 22.6337C11.9351 22.4836 11.8508 22.2801 11.8508 22.068V21.468C11.8504 21.1014 11.7665 20.7398 11.6053 20.4105C11.4442 20.0813 11.2101 19.7931 10.9208 19.568Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8507 26.0684H19.8507",
    stroke: "#FBBC05",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9208 19.568C9.9698 18.825 9.1995 17.8763 8.66778 16.7929C8.13605 15.7095 7.85675 14.5198 7.85083 13.313C7.82683 8.97697 11.3228 5.36797 15.6578 5.26797C17.3378 5.22728 18.988 5.71667 20.3742 6.66671C21.7604 7.61675 22.8122 8.97919 23.3804 10.5607C23.9486 12.1423 24.0043 13.8626 23.5397 15.4775C23.075 17.0925 22.1136 18.5202 20.7918 19.558C20.5003 19.784 20.264 20.0735 20.101 20.4044C19.938 20.7354 19.8524 21.0991 19.8508 21.468V22.068C19.8508 22.2801 19.7665 22.4836 19.6165 22.6337C19.4665 22.7837 19.263 22.868 19.0508 22.868H12.6508C12.4387 22.868 12.2352 22.7837 12.0851 22.6337C11.9351 22.4836 11.8508 22.2801 11.8508 22.068V21.468C11.8504 21.1014 11.7665 20.7398 11.6053 20.4105C11.4442 20.0813 11.2101 19.7931 10.9208 19.568Z",
    stroke: "#FBBC05",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6512 8.46875C18.6512 8.80575 20.3122 10.4688 20.6512 12.4688",
    stroke: "#FBBC05",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_2397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6,
    height: 25.6,
    fill: "white",
    transform: "translate(3.05115 2.86816)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.e166d4271cbf5761845dd0fa7b3e3da9.svg";
export { ForwardRef as ReactComponent };